import api from './api'
import { PaymentResult } from '../types/PaymentResult'

export const getPaymentStatus = async (paymentPageId: string, transactionId: number): Promise<PaymentResult> => {
    return await api('/api/payment-page/result', { paymentPageId, transactionId }) as PaymentResult
}
